const routes = [
  {
    path: '/online-presence',
    name: 'online-presence',
    component: () => import(/* webpackChunkName: "OnlinePresencePage" */ './views/OnlinePresencePage.vue'),
    meta: {
      i18n: 'online-presence-pov',
      pageNameEn: 'Online Presence',
    },
  },
];

export default routes;
